// extracted by mini-css-extract-plugin
export var gif = "_do-0";